import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import {
  Box,
  Container,
  Grid,
  Divider,
  Link,
  DialogActions,
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  useTheme,
  useMediaQuery
} from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { styled } from '@mui/material/styles';
// import { getFileFromLib } from '../../services/dataService';
import LastUpdate from '../../last-update/LastUpdate';
import Footer from '../../footer/Footer';
// import { ChubbLogo } from '../../components/common/ChubbLogo';
import { PAGES } from "../../../constants";
import "./Splash.scss"
import TermsModal from '../../terms-modal/TermsModal';

// Styled components
const SplashContainer = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative'
}));

const VideoBackground = styled('video')(({ theme }) => ({
  opacity: .10,
  position: "absolute",
  top: '50%',
  left: '50%',
  minHeight: "100%",
  minWidth: "100%",
  zIndex: -1,
  transform: "translateY(-50%) translateX(-50%)"
}));

const BorderedContent = styled(Box)(({ theme }) => ({
  borderLeft: `4px solid ${theme.palette.primary.main}`,
  paddingLeft: theme.spacing(2),
  marginBottom: theme.spacing(4)
}));

const Splash = () => {
  const [isTermsModalOpen, setTermsModalOpen] = useState(false);
  const [splashMessage, setSplashMessage] = useState('');
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const termsCondlines = PAGES['splash'].contents.termsConditionsText.text.split(/<br\s*\/?>/i);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        // const content = await getFileFromLib("chubb-ci-pages-content.json");
        setSplashMessage(PAGES['splash'].contents.text);
      } catch (error) {
        console.error('Error fetching content:', error);
      }
    };

    fetchContent();
  }, []);

  const handleEnter = () => {
    // Restore background image before navigation
  const backgroundElement = document.querySelector('.app-background');
  if (backgroundElement) {
    backgroundElement.setAttribute('style', 'background-image: url("/assets/images/defaultBG.png") ');
  }
    navigate('/incident-growth');
  };

  return (
    <SplashContainer>
      {!isMobile && (
        <Box sx={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            overflow: "hidden",
          }}>
          <VideoBackground autoPlay muted loop>
            <source src="/assets/images/video/cyberIndex_v_dissolve.mp4" type="video/mp4" />
          </VideoBackground>
        </Box>
      )}

      <Container maxWidth="lg" sx={{ zIndex: 1}}>
        {/* Header Row */}
        <Grid container alignItems="center" spacing={2} sx={{ mb: 6, mt: 6 }}>
          <Grid size={{xs:12, sm:2}}>
            {/* Brand Logo */}
            <Box sx={{ maxWidth: 130 }} className="brand-logo">
              {/* SVG logo here */}
              <svg id="CHUBB_Logo_Black_T" xmlns="http://www.w3.org/2000/svg" width="356.2" height="36.024" viewBox="0 0 356.2 36.024">
                <path id="Fill-1" d="M49.058,6.584V.158H9.206C3.087.158,0,3.294,0,8.386v19.54c0,5.092,3.087,8.228,9.206,8.228H49.058V29.725H6.943V6.584Zm26.587,8.28V.158H68.857v36h6.787V21.19H111.9V36.153h6.79v-36H111.9V14.864ZM184.611.158V29.725H148.874V.158h-6.79V27.926c0,5.092,3.087,8.228,9.206,8.228H182.2c6.119,0,9.206-3.136,9.206-8.228V.158Zm71.942,36c6.683,0,9.77-2.777,9.77-7.56V24.379a3.157,3.157,0,0,0-1.441-2.777l-4.319-3.7,4.319-3.7a3.16,3.16,0,0,0,1.441-2.777v-3.7c0-4.782-3.087-7.557-9.77-7.557H214.8v36ZM221.585,15.02h37.8V6.277h-37.8Zm0,15.015h37.8v-9h-37.8Zm107.989,6.119c6.686,0,9.77-2.777,9.77-7.56V24.379A3.157,3.157,0,0,0,337.9,21.6l-4.319-3.7,4.319-3.7a3.16,3.16,0,0,0,1.441-2.777v-3.7c0-4.782-3.084-7.557-9.77-7.557H287.818v36ZM294.606,15.02h37.8V6.277h-37.8Zm0,15.015h37.8v-9h-37.8Z" transform="translate(0 -0.129)" fillRule="evenodd"/>
                <path id="Fill-2" d="M138.579,4.758a1.8,1.8,0,0,0,.546-.112.833.833,0,0,0,.382-.3.966.966,0,0,0,.146-.562.916.916,0,0,0-.112-.486.86.86,0,0,0-.3-.3,1.273,1.273,0,0,0-.429-.151,3.059,3.059,0,0,0-.5-.039h-1.279V4.778h.923C138.163,4.778,138.371,4.771,138.579,4.758Zm-2.249,3.134V2.22h2.177a2.044,2.044,0,0,1,1.4.4,1.5,1.5,0,0,1,.442,1.168,1.76,1.76,0,0,1-.112.648,1.376,1.376,0,0,1-.309.468,1.588,1.588,0,0,1-.455.3,2.681,2.681,0,0,1-.549.164l1.688,2.52H139.8l-1.6-2.52h-1.173v2.52Zm.125-6.714a4.038,4.038,0,0,0-2.177,2.229,4.326,4.326,0,0,0-.309,1.649,4.317,4.317,0,0,0,.309,1.649,4.032,4.032,0,0,0,2.177,2.231,4.163,4.163,0,0,0,4.611-.9,4.222,4.222,0,0,0,1.186-2.983,4.282,4.282,0,0,0-.315-1.649,4.19,4.19,0,0,0-.871-1.331A4.1,4.1,0,0,0,138.111.847,4.087,4.087,0,0,0,136.454,1.177Zm3.594-.653a4.723,4.723,0,0,1,1.558,1.043,4.834,4.834,0,0,1,1.035,1.563,4.939,4.939,0,0,1,.377,1.924,4.931,4.931,0,0,1-.377,1.932,4.751,4.751,0,0,1-2.593,2.585,5.172,5.172,0,0,1-3.877,0,4.751,4.751,0,0,1-2.593-2.585,4.935,4.935,0,0,1-.377-1.932,4.943,4.943,0,0,1,.377-1.924,4.883,4.883,0,0,1,1.035-1.563A4.728,4.728,0,0,1,136.171.524a5.172,5.172,0,0,1,3.877,0Z" transform="translate(213.182 -0.147)" fillRule="evenodd"/>
              </svg>
            </Box>
          </Grid>
          <Grid size={{xs:12, sm:6}}  sx={{ textAlign: { xs: 'left', sm: 'right' } }} offset={"auto"}>
            <LastUpdate componentLocation="header" />
          </Grid>
        </Grid>

        {/* Main Content */}
        <Grid container spacing={2} className="splash-mid">
          <Grid size={{xs:6, md:10}}>
            <Typography variant='h3' color='text.primary' sx={{ display: { xs: 'none', sm: 'block' }, mb: 2 }}>
              Chubb Cyber Index®
            </Typography>
            <BorderedContent>
              <Typography variant='h5' sx={{mt: 4}}>
                {splashMessage}
              </Typography>
            </BorderedContent>
            <Divider sx={{ display: { xs: 'block', sm: 'none' }, my: 2 }} />
          </Grid>
        </Grid>

        {/* Terms and Enter Button */}
        <Grid container spacing={2}>
          <Grid size={{xs:12}}>
            <Typography variant='h6' sx={{ mb: 4 }}>
              By clicking below to enter you are agreeing to our{' '}
              <Link
                component="button"
                onClick={() => setTermsModalOpen(true)}
                data-cta="Terms & Conditions"
                underline="none"
                sx={{
                  textTransform: 'none',
                  p: 0,
                  minWidth: 'unset',
                  fontSize: 'inherit',
                  verticalAlign: 'baseline',
                  lineHeight: 'inherit',
                  display: 'inline', // <--- important!
                }}
              >
                terms & conditions.
              </Link>
            </Typography>
          </Grid>
          <Grid size={{xs:12}}>
            <Button
              variant="contained"
              endIcon={<ChevronRightIcon />}
              onClick={handleEnter}
              data-cta="Agree & Enter"
              size='large'
              sx={{ mb: 2, textTransform: 'none', fontSize: '1.25rem', lineHeight: '1rem' }}
            >
              Enter
            </Button>
          </Grid>
        </Grid>

        {/* Browser Note */}
        <Grid container spacing={2}>
          <Grid size={{xs:12}}>
            <Typography variant="subtitle1" className="browsers-note" sx={{ mt: 2, display: 'block', fontStyle: 'italic' }}>
              To guarantee a secure and optimal experience, we recommend using the most recent version of Chrome, Safari or Edge.
            </Typography>
          </Grid>
        </Grid>
      </Container>

      {/* Footer */}
      <Footer componentLocation="splash" />

      {/* Terms Modal */}
      <TermsModal 
        open={isTermsModalOpen} 
        onClose={() => setTermsModalOpen(false)} 
        contentLines={termsCondlines as unknown as string[]}
      />
    </SplashContainer>
  );
};

export default Splash;